import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExpedienteVinculadoDto } from '@models/expedienteVinculado/expedienteVinculadoDto.model';
import { ExpedienteVinculadoService } from '@services/expedienteVinculado/expedienteVinculado.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogFormExpedienteVinculadoComponent } from '../dialog-form-expediente-vinculado/dialog-form-expediente-vinculado.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule, MatSelectionList } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-card-expediente-vinculado',
  standalone: true,
  imports: [CommonModule,
    MatCardModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    NgxSpinnerModule],
  templateUrl: './card-expediente-vinculado.component.html',
  styleUrl: './card-expediente-vinculado.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardExpedienteVinculadoComponent {
   @ViewChild('expedienteVinculadoCount') expedienteVinculadoCount!: MatSelectionList;

  accionesDialog = AccionesDialog;
  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  data = false
  displayedColumns: string[] = [];
  public expedienteVinculadoDto: ExpedienteVinculadoDto[] = [];
  dataSource = new MatTableDataSource<ExpedienteVinculadoDto>();
  isLoading: boolean = true;
  errorMessage: string = "";
  @ViewChild(MatSort) sort!: MatSort
  checkedFiltroAvanzado: boolean = false
  roles: any;
  @Input() idExpediente!: number;
  expedientesVinculados!: ExpedienteVinculadoDto[];

  constructor(
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private expedienteVinculadoService: ExpedienteVinculadoService,
    private dialog: MatDialog,
  ) {
  }

  private paginator!: MatPaginator;

  ;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  ngOnInit(): void {
    this.getAllByIdExpediente(this.idExpediente);
  }



  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro() {
    this.getAllByIdExpediente(this.idExpediente);
  }

  applyFilter(event: any) {
    if (event && event.target && event.target instanceof HTMLInputElement) {
      let filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  getAllByIdExpediente(idExpediente: number) {
    this.spinner.show("spExpedienteVinculado");
    this.expedienteVinculadoService.getAllByIdExpediente(idExpediente)
      .subscribe(
        data => {
          this.spinner.hide("spExpedienteVinculado");
          this.expedientesVinculados = data
        },
        error => {
          this.spinner.hide("spExpedienteVinculado");
          this.snackBar.showError(error, "Error");
        });
  }


  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;
    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "70%"
        break;

      default:
        dialogConfig.width = "50%"
        break;
    }

    const dialogRef = this.dialog.open(DialogFormExpedienteVinculadoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.getAllByIdExpediente(this.idExpediente)
          break;
        case AccionesDialog.Modificar:
          this.getAllByIdExpediente(this.idExpediente)
          break;
        case AccionesDialog.Eliminar:
          this.getAllByIdExpediente(this.idExpediente)
          break;
        default:

          break;
      }

    });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = (data: any, filter: string) => {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.userName) !== -1
        && data.estado.toString().toLowerCase().indexOf(searchTerms.activo) !== -1
    }
    return filterFunction;
  }

  ngAfterViewInit() {
  }

  // Tu función existente para eliminar uno
  eliminar(idExpedienteVinculado: number) {
    this.spinner.show("spExpedienteVinculado")
    this.expedienteVinculadoService.delete(idExpedienteVinculado)
      .subscribe(
        data => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showSuccess('Registro desvinculado correctamente.', "Exito");
        },
        error => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showError(error, "Error");
        })
  }

  // Nueva función para eliminar múltiples seleccionados
  desvincularExpedientes() {
    if (!this.expedienteVinculadoCount?.selectedOptions?.selected) {
      return;
    }

    const selectedOptions = this.expedienteVinculadoCount.selectedOptions.selected;

    if (selectedOptions.length === 0) {
      return;
    }

    // Obtener los IDs de los expedientes seleccionados
    const selectedIds = selectedOptions.map(option => {
      const index = option.value;
      return this.expedientesVinculados[index].id; // Asume que tienes un campo 'id'
    });

    this.eliminarMultiples(selectedIds);
  }

  eliminarMultiples(ids: number[]) {
    this.spinner.show("spExpedienteVinculado");

    const deleteObservables = ids.map(id =>
      this.expedienteVinculadoService.delete(id)
    );

    forkJoin(deleteObservables).subscribe(
      (results) => {
        this.spinner.hide("spExpedienteVinculado");

        this.expedientesVinculados = this.expedientesVinculados.filter(
          expediente => !ids.includes(expediente.id)
        );

        this.expedienteVinculadoCount.deselectAll();

        this.snackBar.showSuccess(
          `${ids.length} registro(s) desvinculado(s) correctamente.`,
          "Exito"
        );
      },
      (error) => {
        this.spinner.hide("spExpedienteVinculado");
        this.snackBar.showError(error, "Error");
      }
    );
  }

}
